import api, { baseApiService } from "shared/api";
import useSWR from "swr";
import { ACCOUNTS_PAYABLE_QUEUE_TYPES } from "entities/Request";

export const requestsListFetcher = ([
  url,
  userRole,
  queue,
  countryCode,
  pageIndex,
  pageSize,
  searchQuery,
  sortingId,
  sortingDesc,
]) =>
  api
    .post(url, {
      user_role: userRole,
      country_code: countryCode,
      queue,
      page_index: pageIndex,
      page_size: pageSize,
      search_query: searchQuery,
      sorting_id: sortingId,
      sorting_desc: sortingDesc,
    })
    .then((res) => res.data);

export function useRequestsList(
  {
    userRole,
    queue = null,
    countryCode = undefined,
    pagination = null,
    searchQuery = null,
    sorting = null,
  },
  options = {}
) {
  return useSWR(
    userRole &&
      // Do not send request if search query is an empty string in search queue
      // TODO Do it better after pagination deploy
      !(queue === ACCOUNTS_PAYABLE_QUEUE_TYPES.SEARCH && !searchQuery?.length)
      ? [
          // TODO Remove temporary "queue_with_pagination" endpoint for AP queues after pagination gets introduced into the rest of these
          Object.values(ACCOUNTS_PAYABLE_QUEUE_TYPES).includes(queue)
            ? baseApiService.ENDPOINTS.request.shared.queue_with_pagination
            : baseApiService.ENDPOINTS.request.shared.queue,
          userRole,
          queue,
          countryCode,
          pagination?.pageIndex,
          pagination?.pageSize,
          searchQuery,
          sorting?.id,
          sorting?.desc,
        ]
      : null,
    requestsListFetcher,
    {
      revalidateOnFocus: false,
      errorRetryInterval: 10000,
      ...options,
    }
  );
}
